import { useNavigate } from "react-router-dom";

export default function PagoOk() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 20 }}>
      <h2>Pago correcto ✅</h2>
      <p>Gracias. Tu inscripción se ha completado.</p>
      <p>
        No vuelva hacia atrás, en unos minutos recibirás un email de confirmación,en caso de no recibirlo revise su bandeja de correo spam o póngase en contacto con soporte técnico. Ahora
        puede dirigirse a la página de inicio.
      </p>

      <button
        onClick={() => navigate("/", { replace: true })}
        style={{
          marginTop: 12,
          padding: "10px 14px",
          fontWeight: 800,
          cursor: "pointer",
        }}
      >
        Ir a inicio
      </button>
    </div>
  );
}